import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"git-merge"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 6C8 7.38071 6.88071 8.5 5.5 8.5C4.11929 8.5 3 7.38071 3 6C3 4.61929 4.11929 3.5 5.5 3.5C6.88071 3.5 8 4.61929 8 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 18C21 19.3807 19.8807 20.5 18.5 20.5C17.1193 20.5 16 19.3807 16 18C16 16.6193 17.1193 15.5 18.5 15.5C19.8807 15.5 21 16.6193 21 18Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 18C8 19.3807 6.88071 20.5 5.5 20.5C4.11929 20.5 3 19.3807 3 18C3 16.6193 4.11929 15.5 5.5 15.5C6.88071 15.5 8 16.6193 8 18Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18.5 15.5V14.5C18.5 12.8431 17.1569 11.5 15.5 11.5H8.5C6.84315 11.5 5.5 10.1569 5.5 8.5M18.5 15.5C17.1193 15.5 16 16.6193 16 18C16 19.3807 17.1193 20.5 18.5 20.5C19.8807 20.5 21 19.3807 21 18C21 16.6193 19.8807 15.5 18.5 15.5ZM5.5 8.5C6.88071 8.5 8 7.38071 8 6C8 4.61929 6.88071 3.5 5.5 3.5C4.11929 3.5 3 4.61929 3 6C3 7.38071 4.11929 8.5 5.5 8.5ZM5.5 9V15M8 18C8 19.3807 6.88071 20.5 5.5 20.5C4.11929 20.5 3 19.3807 3 18C3 16.6193 4.11929 15.5 5.5 15.5C6.88071 15.5 8 16.6193 8 18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GitMerge = Vue.extend<IconProps>({
  name: 'GitMergeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'git-merge',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GitMerge;
